// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */

import { Box, Link } from '@mui/material';
import useIntegrations from '../../hooks/integrations/useIntegrations';

export const EdgeProIntegration = () => {
  const { getIntegrationsLinksBlock } = useIntegrations();

  return (
    <Box>
      <p>
        <em>EdgePro files from Edge Clear update automatically each day</em>.
      </p>
      {getIntegrationsLinksBlock('edge', ['SPY', 'QQQ'])}
    </Box>
  );
};
